import React from 'react'

import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import { withStyles } from '@material-ui/core/styles'
import startCase from 'lodash/startCase'
import toLower from 'lodash/toLower'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import * as Model from 'api/model'
import * as PoziUtils from 'api/utils'
import { setLayerReport } from 'drawer/tabs/layers/actions'
import { printUIOpen } from 'utils/Print/actions'

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    width: '250px',
    'text-align': 'left',
    'margin-left': 0,
    'padding-left': 0,
    'border-left': 0
  },
  selectEmpty: {
    marginTop: theme.spacing(2)
  },
  cssLabel: {
    'font-weight': 'normal',
    '&$cssFocused': {
      color: '#424242'
    }
  },
  cssFocused: {}
})

class LayerReportPropSelect extends React.Component {
  component = this

  constructor (props) {
    super(props)
    const { layer } = this.component.props
    if (layer && layer.reportGroup && layer.reportGroup.prop) {
      this.state = {
        selectedProp: layer.reportGroup.prop
      }
    } else {
      this.state = {
        selectedProp: ''
      }
    }
  }

  componentDidMount () {
    const { geojson } = this.props
    this.setState({ geojson })
  }

  handleChange = event => {
    const { titleid, layer, setLayerReport, dispatchPrintUIOpen } = this.component.props
    this.setState({ [event.target.name]: event.target.value })
    const reportGroup = Object.assign({}, layer.reportGroup) // TODO: Add this to the action so this copy is not required.
    let bPrint = true
    if (event.target.value && event.target.value !== '' && event.target.value !== '(None)') {
      reportGroup.prop = event.target.value
      Model.set('config.layout.drawer.tabs.tools.print.report', true)
      Model.set('config.layout.drawer.tabs.tools.print.reportlayer', layer)
    } else {
      bPrint = false
      reportGroup.prop = ''
      reportGroup.value = ''
      Model.set('config.layout.drawer.tabs.tools.print.report', false)
    }

    // console.debug('LayerReportPropSelect - handleChange - set layer report', titleid, reportGroup)

    setLayerReport(titleid, reportGroup) // Update Redux Store

    console.log('handleChange report group', layer)
    console.log('LayerReportPropSelect.handleChange print report', layer)
    if (bPrint) {
      dispatchPrintUIOpen()
    }

    // printStart()
  }

  render () {
    const { classes, layerAttributes, titleid, selectValues, geojson, layer } = this.props
    if (!selectValues || selectValues.length === 0 || !geojson || !titleid || titleid === '') {
      console.log('render - No selectValues, geojson or titleid. Not rendering.', titleid, selectValues, geojson)
      return null
    }

    if (!layer) {
      console.log('render - no layer. Not rendering.', titleid, layer)
      return null
    }

    if (!layer.selected && !layer.visible) {
      console.log('render - layer not selected/visible. Not rendering.', titleid, layer.selected, layer.visible, layer)
      return null
    }

    const noneKey = 'layers-report-select-options-none-' + titleid
    const menuItemArr = []
    menuItemArr.push(
      <MenuItem key={noneKey} value="(None)">
        <em>(None)</em>
      </MenuItem>
    )
    let sortedArr = selectValues.sort()
    sortedArr = PoziUtils.removeExcludedPropertiesFromArray(sortedArr)

    for (const [index, value] of sortedArr.entries()) {
      const key = 'layers-report-select-options-' + titleid + '-' + index

      // Use field alias as label instead of value if provided in attributes
      const label = layerAttributes?.[value]?.alias || value

      const labelDisplay = startCase(toLower(label))
      menuItemArr.push(
        <MenuItem key={key} value={value}>
          <em>{labelDisplay}</em>
        </MenuItem>
      )
    }

    const id = 'layers-report-select-options-' + titleid

    return (
      <div className="pozi-layer-report-prop-select">
        <form className={classes.root} autoComplete="off">
          <FormControl className={classes.formControl}>
            <InputLabel
              shrink
              classes={{
                root: classes.cssLabel,
                focused: classes.cssFocused
              }}
              htmlFor={id}
            >
              Data Grouping...
            </InputLabel>
            <Select
              value={this.state.selectedProp}
              onChange={this.handleChange}
              displayEmpty
              inputProps={{
                name: 'selectedProp',
                id
              }}
            >
              {menuItemArr}
            </Select>
          </FormControl>
        </form>
      </div>
    )
  }
}

LayerReportPropSelect.propTypes = {
  classes: PropTypes.object.isRequired,
  titleid: PropTypes.string.isRequired,
  selectValues: PropTypes.array,
  geojson: PropTypes.object,
  setLayerReport: PropTypes.func.isRequired,
  layer: PropTypes.object.isRequired,
  layerAttributes: PropTypes.object,
  dispatchPrintUIOpen: PropTypes.func.isRequired
}

function mapStateToProps (state, ownProps) {
  const layerConf = state.layers[ownProps.titleid]
  const layerAttributes = layerConf.attributes

  return {
    layer: layerConf,
    layerAttributes
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setLayerReport: (titleid, reportGroup) => {
      dispatch(setLayerReport(titleid, reportGroup))
    },
    dispatchPrintUIOpen: () => {
      dispatch(printUIOpen())
    }
  }
}

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(LayerReportPropSelect)
)
